<template>
  <div class="mt-6">
    <div v-if="game">
      <div style="height: 14px; width: 250px; padding-left: 30px; margin-bottom: 4px;">
        <div
          v-if="state == 3 || state == 4"
          class="level is-size-7 is-mobile"
          style="margin-bottom: 0;"
        >
          <div class="level-left">{{ game.round }}/13</div>
          <div
            class="level-right"
          >{{ game.bidCount }}{{ game.trump | getSuit }} {{ game.bidWinner | positionToChar }}</div>
        </div>
        <div v-if="state == 2 && game.currentTurn == topPosition">
          <span class="icon">
            <i class="fas fa-arrow-up"></i>
          </span>
        </div>
      </div>
      <div class="level is-mobile" style="margin-bottom: 0;">
        <div class="level-item" style="width: 12px;">
          <span class="icon" v-if="state == 2 && game.currentTurn == leftPosition">
            <i class="fas fa-arrow-left"></i>
          </span>
        </div>
        <div class="center-square">
          <div v-if="clientState == 0 && state < 2">
            <div>
              <input
                class="input mt-6"
                style="width: 180px;"
                v-model="name"
                type="text"
                placeholder="Name"
                maxlength="6"
              />
            </div>
            <div>
              <button class="button mt-4 is-info" :disabled="!name" v-on:click="joinRoom()">Start</button>
            </div>
          </div>
          <div v-if="clientState > 0 && state < 2" class="mt-6">
            <span>Waiting for players...</span>
          </div>
          <div v-if="state == 2" class="ml-1 mt-3">
            <BidBoxComponent
              v-bind:selectedBids="game.bids"
              v-bind:currentPosition="game.currentTurn"
              v-bind:userPosition="user.position"
            ></BidBoxComponent>
          </div>
          <div v-if="state==3">
            <div style="margin-top: 20px; height: 80px;">
              <div
                v-if="northCard"
                class="enabled-card animate__animated animate__slideInDown"
                v-bind:class="{
                  'disabled-card': game.roundWinners.length == game.round && topPosition != game.roundWinners[game.round - 1]
                  }"
              >
                <div v-if="northCard == 'AD'">
                  <img class="img-card" :src="require(`@/assets/cards/AceDiamond.png`)" />
                </div>
                <div v-else>
                  <img class="img-card" :src="require(`@/assets/cards/`+ northCard + `.png`)" />
                </div>
              </div>
              <div v-else>
                <div v-if="game.currentTurn == topPosition">
                  <span class="icon" style="font-size: 2em;">
                    <i class="fas fa-arrow-up"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="level is-mobile" style="margin-bottom: 0; margin-top: -40px; height: 80px;">
              <div class="level-item">
                <div
                  v-if="westCard"
                  class="enabled-card animate__animated animate__slideInLeft"
                  v-bind:class="{
                  'disabled-card': game.roundWinners.length == game.round && leftPosition != game.roundWinners[game.round - 1]
                  }"
                >
                  <div v-if="westCard == 'AD'">
                    <img class="img-card" :src="require(`@/assets/cards/AceDiamond.png`)" />
                  </div>
                  <div v-else>
                    <img class="img-card" :src="require(`@/assets/cards/`+ westCard + `.png`)" />
                  </div>
                </div>
                <div v-else>
                  <div v-if="game.currentTurn == leftPosition">
                    <span class="icon" style="font-size: 2em; margin-left: -24px!important;">
                      <i class="fas fa-arrow-left"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="level-item">
                <div
                  v-if="eastCard"
                  class="enabled-card animate__animated animate__slideInRight"
                  v-bind:class="{
                  'disabled-card': game.roundWinners.length == game.round && rightPosition != game.roundWinners[game.round - 1]
                  }"
                >
                  <div v-if="eastCard == 'AD'">
                    <img class="img-card" :src="require(`@/assets/cards/AceDiamond.png`)" />
                  </div>
                  <div v-else>
                    <img class="img-card" :src="require(`@/assets/cards/`+ eastCard + `.png`)" />
                  </div>
                </div>
                <div v-else>
                  <div v-if="game.currentTurn == rightPosition">
                    <span class="icon" style="font-size: 2em;">
                      <i class="fas fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: -40px; height: 80px;">
              <div
                v-if="southCard"
                class="enabled-card animate__animated animate__slideInUp"
                v-bind:class="{
                  'disabled-card': game.roundWinners.length == game.round && bottomPosition != game.roundWinners[game.round - 1]
                  }"
              >
                <div v-if="southCard == 'AD'">
                  <img class="img-card" :src="require(`@/assets/cards/AceDiamond.png`)" />
                </div>
                <div v-else>
                  <img class="img-card" :src="require(`@/assets/cards/`+ southCard + `.png`)" />
                </div>
              </div>
              <div v-else>
                <div v-if="game.currentTurn == bottomPosition">
                  <span class="icon" style="font-size: 2em; margin-top: 60px;">
                    <i class="fas fa-arrow-down"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="state==4">
            <div class="my-6 is-size-5">
              <div v-if="game.winner > -1">
                🏆
                <span v-if="game.winner == 0">NS</span>
                <span v-if="game.winner == 1">EW</span>
                wins! 🏆  
                <div
                  v-if="game.claimPosition > -1"
                >{{game.claimPosition | positionToString}} claimed.</div>              
              </div>
              <div v-else>Game ended.</div>
            </div>
            <button
              v-if="clientState == 2"
              class="button is-small mr-4 is-success has-text-dark"
              v-on:click="restart()"
            >RESTART</button>
            <button
              v-if="clientState == 2"
              class="button is-small is-link"
              v-on:click="stand()"
            >STAND</button>
          </div>
        </div>
        <div class="level-item" style="width: 12px;">
          <span class="icon" v-if="state == 2 && game.currentTurn == rightPosition">
            <i class="fas fa-arrow-right"></i>
          </span>
        </div>
      </div>
      <div style="height: 14px; width: 250px; padding-left: 30px;">
        <div v-if="state == 3 || state == 4" class="level is-size-7 is-mobile">
          <div class="level-left">
            NS {{ game.nsCount }}/{{
            game.bidWinner == 0 || game.bidWinner == 2 ? 6 + Number(game.bidCount) : 8 - Number(game.bidCount)
            }}
          </div>
          <div class="level-right">
            EW {{ game.ewCount }}/{{
            game.bidWinner == 1 || game.bidWinner == 3 ? 6 + Number(game.bidCount) : 8 - Number(game.bidCount)
            }}
          </div>
        </div>
        <div v-if="state == 2 && game.currentTurn == bottomPosition">
          <span class="icon">
            <i class="fas fa-arrow-down"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BidBoxComponent from "@/components/BidBoxComponent.vue";
import socketStore from "@/service/socketStore";

export default {
  name: "CenterComponent",
  components: {
    BidBoxComponent,
  },
  props: {
    game: Object,
    user: Object,
    state: Number,
    clientState: Number,
    topPosition: Number,
    rightPosition: Number,
    leftPosition: Number,
    bottomPosition: Number,
  },
  data: () => {
    return {
      name: "",
    };
  },
  computed: {
    northCard: function () {
      return this.getCard(this.topPosition);
    },
    southCard: function () {
      return this.getCard(this.bottomPosition);
    },
    eastCard: function () {
      return this.getCard(this.rightPosition);
    },
    westCard: function () {
      return this.getCard(this.leftPosition);
    },
  },
  methods: {
    restart() {
      socketStore.emit("restart_game", "");
    },
    stand() {
      socketStore.emit("stand_user");
    },
    joinRoom() {
      var userId = Math.random().toString(36).substring(7);
      socketStore.setUserId(userId);

      var user = {
        username: this.name,
        userId: userId,
      };

      localStorage.setItem(socketStore.state.roomId, JSON.stringify(user));
      socketStore.emit("join_room", this.name);
    },
    getCard(position) {
      var card = "";
      if (this.game && this.game.rounds) {
        var temp = this.game.rounds[this.game.round - 1].find(
          (p) => p.position == position
        );
        if (temp) {
          card = temp.card;
        }
      }
      return card;
    },
  },
};
</script>

<style>
.center-square {
  height: 230px;
  width: 230px;
  border: 1px solid rgba(253, 118, 118, 0.2);
}
</style>